import classNames from "classnames";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { EventsState } from "../../../store/types";

import { TemplateClassNames, TemplateNames } from "../../../types/template-layouts";
import {
	EPreviewTypes,
	PageModuleType, Session,
	// Profile,
} from "../../../types/working-model";
import "./marketing-registered-page.scss";

import WaitingIndicator from "../../general-ui/waiting-indicator/waiting-indicator";
import About from "../modules/about/about";
import Agenda from "../modules/agenda/agenda";
import CallOut from "../modules/call-out/call-out";
import MainEventBannerLive from "../modules/main-event-banner-live/main-event-banner-live";
import MainEventBanner from "../modules/main-event-banner/main-event-banner";
import Products from "../modules/products/products";
import Speakers from "../modules/speakers/speakers";
import Sponsors from "../modules/sponsors/sponsors";
import Videos from "../modules/video/videos";
import Footer from "./footer/footer";
import MarketingNav from "./navigation/marketing-nav";
import { checkIsLive } from "../../../utils/utils";
import BlankSection from "../modules/blank-section/blank-section";

function sortSessionsByTime(a: Session, b: Session) {
	if (a.session_type === 'on-demand') {
		return 1;
	}

	return Math.abs(a.timestamp! - b.timestamp!);
}

export const MarketingRegisteredPage = (): JSX.Element => {
	const {
		LiveEventReducer: { eventBundle },
		CreateEventReducer: { workingEvent, previewMode },
	} = useSelector((event: EventsState) => event);
	const isPreview = previewMode === EPreviewTypes.Home;
	const homepage = isPreview ? workingEvent?.homepage : eventBundle?.homepage;
	const template = (isPreview ? workingEvent?.template.name : eventBundle?.template.name) || TemplateNames.Classic;
	const sessions = isPreview ? workingEvent?.sessions : eventBundle?.sessions;
	const logo = isPreview ? workingEvent?.homepage?.header.logo : eventBundle?.homepage?.header.logo;

	const homepageModules = useMemo(() => {
		if (isPreview) {
			if (!workingEvent || !homepage) return null;
			const sortedSessions: Session[] | undefined = (workingEvent.sessions?.sort(sortSessionsByTime) as Session[] | undefined);

			const liveSession = sortedSessions?.find(checkIsLive);
			const startDate = liveSession?.timestamp ? new Date(liveSession.timestamp) : null;

			return homepage.post_register_home_modules
				.map((module) => {
					// TODO HTML
					if (module.is_on) {
						// get full page_module
						const pageModule = homepage.modules.find(_module => _module.id === module.module_id);
						if (pageModule && !pageModule?.is_on) {
							pageModule.is_on = true;
						}
						switch (pageModule?.type) {
							case PageModuleType.main_event_banner:
								return (
									(liveSession && startDate) ? <MainEventBannerLive
										header={homepage.header}
										module={pageModule}
										template={TemplateClassNames[template]}
										startDate={startDate}
										key={pageModule.id}
										liveSession={liveSession}
									/> :
										<MainEventBanner
											module={pageModule}
											template={TemplateClassNames[template]}
											key={pageModule.id}
											eventBundle={workingEvent}
										/>
								);
							case PageModuleType.about:
								return <About key={pageModule.id} module={pageModule} template={TemplateClassNames[template]} />;
							case PageModuleType.speakers:
								return <Speakers key={pageModule.id} module={pageModule} template={TemplateClassNames[template]} />;
							case PageModuleType.agenda:
								return (
									<Agenda
										isLive={!!liveSession}
										isUpNext={true}
										module={pageModule}
										template={TemplateClassNames[template]}
										sessions={sessions!}
										key={pageModule.id}
										eventBundle={workingEvent}
									/>
								);
							case PageModuleType.callout:
								return <CallOut key={pageModule.id} module={pageModule} template={TemplateClassNames[template]} />;
							case PageModuleType.sponsors:
								return <Sponsors key={pageModule.id} module={pageModule} template={TemplateClassNames[template]} />;
							case PageModuleType.products:
								return <Products key={pageModule.id} module={pageModule} template={TemplateClassNames[template]} />;
							case PageModuleType.videos:
								return <Videos key={pageModule.id} module={pageModule} template={TemplateClassNames[template]} />;
							case PageModuleType.blank:
								return <BlankSection key={pageModule.id} module={pageModule} template={TemplateClassNames[template]} />;
							// TODO: add back post MVP
							// case PageModuleType.people:
							// 	return <PeopleModule key={pageModule.id} module={pageModule} template={TemplateClassNames[template]} />;
						}
					}
				});
		} else {
			if (!eventBundle || !homepage) return null;

			const sortedSessions: Session[] | undefined = (eventBundle.sessions?.sort(sortSessionsByTime) as Session[] | undefined);

			const liveSession = sortedSessions?.find(checkIsLive);
			const startDate = liveSession?.timestamp ? new Date(liveSession.timestamp) : null;

			return homepage.post_register_home_modules
				.map((module) => {
					// TODO HTML
					if (module.is_on) {
						// get full page_module
						const pageModule = homepage.modules.find(_module => _module.id === module.module_id);
						if (pageModule && !pageModule?.is_on) {
							pageModule.is_on = true;
						}
						switch (pageModule?.type) {
							case PageModuleType.main_event_banner:
								return (
									(liveSession && startDate) ? <MainEventBannerLive
										header={homepage.header}
										module={pageModule}
										template={TemplateClassNames[template]}
										startDate={startDate}
										key={pageModule.id}
										liveSession={liveSession}
									/> :
										<MainEventBanner
											module={pageModule}
											template={TemplateClassNames[template]}
											key={pageModule.id}
											eventBundle={eventBundle}
										/>
								);
							case PageModuleType.about:
								return <About key={pageModule.id} module={pageModule} template={TemplateClassNames[template]} />;
							case PageModuleType.speakers:
								return <Speakers key={pageModule.id} module={pageModule} template={TemplateClassNames[template]} />;
							case PageModuleType.agenda:
								return (
									<Agenda
										isLive={!!liveSession}
										isUpNext={true}
										module={pageModule}
										template={TemplateClassNames[template]}
										sessions={sessions!}
										key={pageModule.id}
										eventBundle={eventBundle}
									/>
								);
							case PageModuleType.callout:
								return <CallOut key={pageModule.id} module={pageModule} template={TemplateClassNames[template]} />;
							case PageModuleType.sponsors:
								return <Sponsors key={pageModule.id} module={pageModule} template={TemplateClassNames[template]} />;
							case PageModuleType.products:
								return <Products key={pageModule.id} module={pageModule} template={TemplateClassNames[template]} />;
							case PageModuleType.videos:
								return <Videos key={pageModule.id} module={pageModule} template={TemplateClassNames[template]} />;
							case PageModuleType.blank:
								return <BlankSection key={pageModule.id} module={pageModule} template={TemplateClassNames[template]} />;
							// TODO: add back post MVP
							// case PageModuleType.people:
							// 	return <PeopleModule key={pageModule.id} module={pageModule} template={TemplateClassNames[template]} />;
						}
					}
				});
		}
	}, [eventBundle, homepage, template, sessions, workingEvent, isPreview]);

	if (previewMode === EPreviewTypes.Home) {
		if (!workingEvent) return <WaitingIndicator />;
	} else {
		if (!eventBundle) return <WaitingIndicator />;
	}
	if (!homepage) return <h1>TODO: No Home page(reroute?)</h1>;

	return (
		<div className={classNames('marketing-registered-page')}>
			<MarketingNav showLanguageSelector template={TemplateClassNames[template]} logo={logo ?? undefined} />
			<div className="registered-main-contant">
				{homepageModules}
				{homepage.footer && (
					<Footer footer={homepage.footer} template={TemplateClassNames[template]} />
				)}
			</div>
		</div>
	);
};
